export default __webpack_public_path__ + "static/media/cp_geo_fj.7e4e2c49.svg";